"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _numberFormatter = require("../../helpers/numberFormatter");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _APTable = _interopRequireDefault(require("../common/APTable"));
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
require("./InstrumentSelectorPopupComponent.css");
var _APSelect = require("../common/APSelect");
var _APSearchInput = _interopRequireDefault(require("../common/APSearchInput/APSearchInput"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var InstrumentSelectorPopupComponent = function InstrumentSelectorPopupComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var onRowClick = props.onRowClick,
    level1 = props.level1,
    instruments = props.instruments,
    fetching = props.fetching,
    selectedRow = props.selectedRow,
    customClass = props.customClass,
    showFullNameInstrument = props.showFullNameInstrument;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    instrumentSearchInputString = _useState2[0],
    setInstrumentSearchInputString = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    instrumentFilterSelectedValue = _useState4[0],
    setInstrumentFilterSelectedValue = _useState4[1];
  var baseClasses = (0, _cssClassesHelper.getBEMClasses)('instrument-selector-popup', customClass);
  var processRowsByInput = function processRowsByInput(instrumentRows) {
    return instrumentRows.filter(function (instrument) {
      var matchesSearchInput = showFullNameInstrument ? "".concat(instrument.Product1FullName).concat(instrument.Product2FullName).toLowerCase().includes(instrumentSearchInputString.toLowerCase()) : "".concat(instrument.Product1Symbol).concat(instrument.Product2Symbol).toLowerCase().includes(instrumentSearchInputString.toLowerCase());
      var matchesFilterValue = instrument.Product2Symbol === instrumentFilterSelectedValue;
      if (!instrumentSearchInputString && !instrumentFilterSelectedValue) {
        return true;
      }
      if (!instrumentSearchInputString && (instrumentFilterSelectedValue === 'all' || !instrumentFilterSelectedValue)) {
        return true;
      }
      if (!instrumentSearchInputString && instrumentFilterSelectedValue && instrumentFilterSelectedValue !== 'all') {
        return matchesFilterValue;
      }
      if (instrumentSearchInputString && instrumentFilterSelectedValue === 'all' || !instrumentFilterSelectedValue) {
        return matchesSearchInput;
      }
      if (instrumentSearchInputString && instrumentFilterSelectedValue && instrumentFilterSelectedValue !== 'all') {
        return matchesSearchInput && matchesFilterValue;
      }
    });
  };
  var instrumentRows = (0, _react.useMemo)(function () {
    return instruments.map(function (instrument) {
      var level1Data = level1[instrument.InstrumentId];
      if (!level1Data) {
        return instrument;
      }
      return _objectSpread(_objectSpread({}, instrument), {}, {
        lastTrade: level1Data.LastTradedPx,
        Rolling24HrPxChangePercent: level1Data.Rolling24HrPxChangePercent,
        Rolling24HrVolume: level1Data.Rolling24HrVolume
      });
    });
  }, [instruments, level1]);
  var filteredInstrumentRows = (0, _react.useMemo)(function () {
    if (instrumentSearchInputString || instrumentFilterSelectedValue) {
      return processRowsByInput(instrumentRows);
    }
    return instrumentRows;
  }, [instrumentRows, instrumentSearchInputString, instrumentFilterSelectedValue]);
  var columns = [{
    header: t('Market'),
    classModifier: 'market',
    cell: function cell(instrument) {
      return showFullNameInstrument ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: baseClasses('coin__product1-symbol')
      }, instrument.Product1FullName), /*#__PURE__*/_react["default"].createElement("span", {
        className: baseClasses('coin__product2-symbol')
      }, "/", instrument.Product2FullName)) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: baseClasses('coin__product1-symbol')
      }, instrument.Product1Symbol), /*#__PURE__*/_react["default"].createElement("span", {
        className: baseClasses('coin__product2-symbol')
      }, "/", instrument.Product2Symbol));
    }
  }, {
    header: t('Price'),
    classModifier: 'price',
    cell: function cell(instrument) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: baseClasses('coin__product1-symbol')
      }, instrument.lastTrade.toFixed((0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement)));
    }
  }, {
    header: t('24hr Chg'),
    classModifier: '24hrChg',
    cell: function cell(instrument) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: baseClasses(instrument.Rolling24HrPxChangePercent >= 0 ? '24h-positive' : '24h-negative')
      }, (instrument.Rolling24HrPxChangePercent > 0 ? '+' : '') + (0, _numberFormatter.formatPercentageValue)(instrument.Rolling24HrPxChangePercent));
    }
  }, {
    header: t('Volume'),
    classModifier: 'volume',
    cell: function cell(instrument) {
      return (0, _numberFormatter.formatToThousands)(instrument.Rolling24HrVolume);
    }
  }];
  var currencySelectOptions = (0, _react.useMemo)(function () {
    var symbols = new Set();
    instruments.forEach(function (_ref) {
      var Product2Symbol = _ref.Product2Symbol;
      return symbols.add(Product2Symbol);
    });
    return _toConsumableArray(symbols).map(function (symbol) {
      return {
        value: symbol,
        label: symbol
      };
    });
  }, [instruments]);
  var handleCurrencySelectChange = function handleCurrencySelectChange(value) {
    setInstrumentFilterSelectedValue(value);
  };
  var handleCurrencySearchChange = function handleCurrencySearchChange(e) {
    setInstrumentSearchInputString(e.target.value);
  };
  var onCancelSearchInputClick = function onCancelSearchInputClick() {
    setInstrumentSearchInputString('');
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('search-elements-wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_APSelect.InnerSelect, {
    name: "currencySelect",
    customClass: baseClasses('currency'),
    defaultValue: {
      value: '',
      label: t('Currency'),
      disabled: true
    },
    options: [{
      value: 'all',
      label: t('All')
    }].concat(_toConsumableArray(currencySelectOptions)),
    showTriangles: true,
    onSelect: handleCurrencySelectChange
  }), /*#__PURE__*/_react["default"].createElement(_APSearchInput["default"], {
    value: instrumentSearchInputString,
    onChange: handleCurrencySearchChange,
    onCancel: onCancelSearchInputClick
  })), /*#__PURE__*/_react["default"].createElement(_APTable["default"], {
    fetching: fetching,
    columns: columns,
    rows: filteredInstrumentRows,
    baseClass: baseClasses,
    onRowClicked: function onRowClicked(instrument) {
      return onRowClick(instrument);
    },
    selectedRow: selectedRow,
    empty: t('Zero results for "{{searchInputString}}" with selected filters', {
      searchInputString: instrumentSearchInputString
    })
  }));
};
InstrumentSelectorPopupComponent.propTypes = {
  level1: _propTypes["default"].object.isRequired,
  onRowClick: _propTypes["default"].func.isRequired,
  instruments: _propTypes["default"].array.isRequired,
  fetching: _propTypes["default"].bool.isRequired,
  selectedRow: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = InstrumentSelectorPopupComponent;